import { Player } from '@lottiefiles/react-lottie-player';

import WatchAnimation from '@/_shared/animations/a_watch.json';

export default function AnimationPlayer({
  animation = WatchAnimation,
  height = 144,
  width = 144,
  loop = true,
  autoplay = true,
}) {
  return <Player autoplay={autoplay} loop={loop} src={animation} style={{ height, width }} />;
}
